import store from '../../store/store';
// import Auth from '../../services/Auth';

export default (to, from, next) => {

  if (!store.state.loading.appLoading) {
    return next();
  }

  const templateId = localStorage.getItem('templateId');
  if (templateId && templateId !== 'false') {
    store.commit('authenticators/setTemplateId', templateId);
  }

  const showOtp = localStorage.getItem('showOtp');
  if (showOtp && showOtp !== 'false') {
    store.commit('settings/setShowOtp', showOtp);
  }

  const advancedTemplate = localStorage.getItem('advancedTemplate');
  if (advancedTemplate && advancedTemplate !== 'false') {
    store.commit('settings/setAdvancedTemplate', advancedTemplate);
  }

  const templateFilter = localStorage.getItem('templateFilter');
  if (templateFilter) {
    store.commit('authenticators/setTemplateFilter', JSON.parse(templateFilter));
  }

  const fieldFilter = localStorage.getItem('fieldFilter');
  if (fieldFilter) {
    store.commit('authenticators/setFieldFilter', JSON.parse(fieldFilter));
  }

  store.dispatch('loading/setAppLoading', false);
  return next();

};


// WEBPACK FOOTER //
// ./src/router/guards/AppInit.js